import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  // tslint:disable-next-line:quotemark
  title: "Numéro d'assurance sociale",
  content: [
    'Si votre NAS est perdu ou volé, le gouvernement n&#39;émettra pas de nouveau NAS ou de nouvelle carte d&#39;assurance sociale.',

    '<ul>',
    '<li>La seule façon de recevoir un nouveau numéro est de prouver que votre NAS a été utilisé frauduleusement.</li>',
    '<li>Les cartes de NAS en plastique ont été remplacées par des lettres de « confirmation du NAS » en format papier.</li>',
    '</ul>',

    'Il est important de suivre ces étapes dans le cas d&#39;un NAS perdu ou volé :',
    '<ul>',
    '<li><strong>Visitez immédiatement un bureau de Service Canada.</strong><br />',
    'Signalez la perte ou le vol de votre NAS à un bureau de Service Canada et demandez à recevoir une lettre de',
    'confirmation du NAS gratuitement. Remplissez le formulaire Demande de renseignements personnels et indiquez',
    'sur le formulaire que vous demandez des copies des formulaires de demande de NAS préalablement soumis en vertu',
    'de la Loi sur la protection des renseignements personnels, Banque EDSC PPU 390. Vous devrez fournir un certificat',
    'de naissance original, un certificat de citoyenneté canadienne, un certificat d&#39;enregistrement de naissance à',
    'l&#39;étranger ou une carte de résident permanent. Dans certains cas, vous devrez peut-être fournir une preuve de',
    'changement de nom, une ordonnance d&#39;adoption, un certificat de mariage ou d&#39;autres documents. Tous les détails sur',
    'les documents d&#39;identité requis se trouvent ici.</li>',

    '<li><strong>Surveiller les activités suspectes</strong><br />',
    'Surveillez vos relevés bancaires, vos relevés de carte de crédit et de débit et vos rapports de crédit en vue de détecter toute activité suspecte et signalez toute irrégularité au service de police et à l’institution financière. Les abonnés au service EnGarde ont accès à la surveillance en ligne, qui les alerte dans le cas où le NAS enregistré est repéré en ligne.</li>',
    '</ul>'
  ].join('\n')
};
